import sourceChannelManagement from './sourceChannelManagement'

export default {
  systemNotificationManagement: {
    title: '站内消息',
    menu: '站内消息'
  },
  jobPosterManagement: {
    title: '我的发布',
    menu: '我的发布'
  },
  customerManagement: {
    title: '客户管理',
    menu: '客户管理'
  },
  adsTierManagement: {
    title: '广告层级管理',
    menu: '广告层级管理'
  },
  pointsManagement: {
    title: '积分管理',
    menu: '积分管理'
  },
  cashManagement: {
    title: '现金管理',
    menu: '现金管理'
  },
  cashOutManagement: {
    title: '奖励发放管理',
    menu: '奖励发放管理'
  },
  serviceAccountManagement: {
    title: '服务账号管理',
    menu: '服务账号管理'
  },
  uploadDataManagement: {
    title: '上传数据',
    menu: '上传数据'
  },
  schoolManagement: {
    title: '学校管理',
    menu: '学校管理'
  },
  candidateStatusManagement: {
    title: '求职者状态管理',
    menu: '求职者状态管理'
  },
  majorManagement: {
    title: '专业管理',
    menu: '专业管理'
  },
  exportDataManagement: {
    title: '导出数据',
    menu: '导出数据'
  },
  sourceChannelManagement,
  userManagement: {
    title: '用户注销',
    menu: '用户注销'
  }
}
